/**
 * Блокировка скролла страницы со счётчиком.
 *
 * Модалок на экране может быть несколько сразу: из боковой шторки открывается
 * попап подтверждения, из него — ещё один. Если бы каждая при закрытии просто
 * возвращала body.style.overflow, закрытие верхней разблокировало бы страницу
 * под всё ещё открытой нижней. Поэтому снимаем блокировку, только когда
 * закрылась последняя: считаем незакрытые блокировки, а не перезаписываем
 * стиль напрямую.
 */
let count = 0;

export default {
  lock() {
    count += 1;
    if (count === 1) document.body.style.overflow = 'hidden';
  },

  unlock() {
    // страховка от лишнего unlock(): счётчик не должен уходить в минус, иначе
    // следующий lock() поднимет его только до нуля и скролл не заблокируется
    if (count === 0) return;

    count -= 1;
    if (count === 0) document.body.style.overflow = 'visible';
  },
};
